import React from "react";
import "../styles/PrivacyPolicy.css";

const POSTS = [
  {
    title: "Understanding RERA: What Every Homebuyer Should Know",
    type: "Guides",
    admin: "Coming soon",
    purpose: "What RERA registration actually protects, and how to verify a project's status before you commit.",
  },
  {
    title: "A First-Time Homebuyer's Guide to Bengaluru",
    type: "Guides",
    admin: "Coming soon",
    purpose: "Micro-markets, commute considerations, and what to budget for beyond the sticker price.",
  },
  {
    title: "How AI Is Changing Property Search",
    type: "Product",
    admin: "Coming soon",
    purpose: "A look at how our AI Property Advisor matches listings to what you actually need.",
  },
  {
    title: "Vastu Considerations for Modern Apartments",
    type: "Guides",
    admin: "Coming soon",
    purpose: "How to weigh vastu preferences alongside layout, budget, and location.",
  },
];

/**
 * Static Blog landing page. There's no CMS/backend for posts yet, so this
 * lists planned articles as teaser cards rather than faking clickable
 * full posts that don't exist.
 */
export default function Blog() {
  return (
    <div className="pp-page">
      <div className="pp-container">

        <div className="pp-hero">
          <div className="pp-hero-badge">Blog</div>
          <h1 className="pp-h1">Insights on Buying, Selling &amp; Renting in India</h1>
          <p className="pp-intro">
            We're building out a library of practical guides on real estate in
            India -- RERA, financing, neighborhoods, and how to use OGM's AI
            Property Advisor to its fullest. Here's what's coming first.
          </p>
        </div>

        <section className="pp-section">
          <h2 className="pp-h2">Upcoming Articles</h2>
          <div className="pp-cookie-grid">
            {POSTS.map((p) => (
              <div className="pp-cookie-card" key={p.title}>
                <div className="pp-cookie-title">{p.title}</div>
                <div className="pp-cookie-row"><span>Category</span><b>{p.type}</b></div>
                <div className="pp-cookie-row"><span>Status</span><b>{p.admin}</b></div>
                <p style={{ fontSize: 13, color: "#64748b", margin: "10px 0 0" }}>{p.purpose}</p>
              </div>
            ))}
          </div>
        </section>

        <div className="pp-contact">
          <div className="pp-contact-icon">✍️</div>
          <h2 className="pp-h2" style={{ marginBottom: 8 }}>Have a topic you'd like us to cover?</h2>
          <p style={{ margin: "0 0 16px" }}>
            Let us know and we'll consider it for an upcoming post.
          </p>
          <a href="mailto:info@oneglobalmarketplace.com?subject=Blog%20Topic%20Suggestion" className="pp-contact-link">
            info@oneglobalmarketplace.com →
          </a>
        </div>

      </div>
    </div>
  );
}
